import React, { useEffect, useState } from 'react';
import './App.css';

import CssBaseline from '@mui/material/CssBaseline';
import Box from '@mui/material/Box';
import Container from '@mui/material/Container/Container';

import { useRecoilValue, useRecoilState } from 'recoil';




import { Header } from 'components/Header';
import { Footer } from 'components/Footer';
import { SystemMenu } from 'components/SystemMenu2';
import { AppRoute } from 'components/Route';



import { LocalizationProvider } from '@mui/x-date-pickers/';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFnsV3';


import { useTheme, lighten, darken, getContrastRatio } from '@mui/material/styles';


import frLocale from 'date-fns/locale/fr';
import ruLocale from 'date-fns/locale/ru';
import deLocale from 'date-fns/locale/de';
import enLocale from 'date-fns/locale/en-US';

import { getUnixTime } from 'date-fns';

import { EntityActionDrawer } from 'components/EntityActionDrawer';
import { EntityPrintDrawer } from 'components/EntityPrintDrawer';

import {
  currentUserSessionAtom, isActionDrawerOpenAtom, isPrintDrawerOpenAtom, isSearchBoxShowAtom, isAuthorizationBoxShowAtom,
  isDesktopPublishingBoxShowAtom, isExportBoxShowAtom,
  colorsAtom
} from 'library/store';
import { FilterBox } from 'components/FilterBox';
import { FilterFormDialog } from 'components/FilterFormDialog';
import { ExportFormDialog } from 'components/ExportFormDialog';
import { DesktopPublishingFormDialog } from 'components/DesktopPublishingFormDialog';

import { AuthorizationFormDialog } from 'components/AuthorizationFormDialog';

import { RequestNotification } from 'components/RequestNotification';
import { SessionTimeout } from 'components/SessionTimeout';
import { displayOnDesktop } from 'themes/commonStyles';
// import { Sidebar } from 'components/Sidebar';
import { Grid } from '@mui/material';
import Sidebar from 'components/Sidebar';
import { grey } from '@mui/material/colors';

const getLocale = (lg: string): any /*Locale*/ => {

  if (lg.includes('fr'))
    return frLocale;
  else if (lg.includes('en'))
    return enLocale;

  return frLocale;
}

function AppWithSideBar() {

  const { isAuthenticated, language, applicationSetup } = useRecoilValue(currentUserSessionAtom);
  const [isActionDrawerOpen, setIsActionDrawerOpen] = useRecoilState(isActionDrawerOpenAtom);
  const [isPrintDrawerOpen, setIsPrintDrawerOpen] = useRecoilState(isPrintDrawerOpenAtom);
  const [isSearchBoxShow, setIsSearchBoxShow] = useRecoilState(isSearchBoxShowAtom);

  const [Colors, setColors] = useRecoilState(colorsAtom);

  const [isAuthorizationBoxShow, setIsAuthorizationBoxShow] = useRecoilState(isAuthorizationBoxShowAtom);

  const [isExportBoxShow, setIsExportBoxShow] = useRecoilState(isExportBoxShowAtom);
  const [isDesktopPublishingBoxShow, setIsDesktopPublishingBoxShow] = useRecoilState(isDesktopPublishingBoxShowAtom);

  const [dateFnsLocale, setDateFnsLocale] = useState<any>(getLocale(language));


  const theme = useTheme();

  const background = Colors.background;

  // Compare with white
  const isBackgroundLight = getContrastRatio(background, '#000') > getContrastRatio(background, '#fff');

  const backgroundForSystemMenu = isBackgroundLight
    ? darken(background, 0.05) // Fond clair → on fonce un peu
    : lighten(background, 0.05); // Fond sombre → on éclaircit

  useEffect(() => {

    setDateFnsLocale(getLocale(language));

  }, [language]);

  const boxProps = {
    display: 'flex',
    flexDirection: 'column',
    flexGrow: 1,
    minHeight: 0,
    //height: 100,
    overflowY: isAuthenticated ? 'scroll' : 'hidden',  //'none',
    overflowX: 'hidden',
    //background: 'green',
    width: '100%' // ensure full width
  }

  return (
    <React.Fragment>
      <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={dateFnsLocale}>
        <CssBaseline />
        <RequestNotification />
        <Grid container sx={{

          height: '100vh',
          // bgcolor:"red"
        }}>



          {isAuthenticated && <Grid item xs={2} ><Box sx={{
            bgcolor: "white",
            height: "100%",
            display: "flex",
            // maxWidth:"10rem"
          }}>
            <Sidebar />
          </Box>  </Grid>}

          <Grid item xs={isAuthenticated ? 10 : 12} sx={{
            // columnSpan:"2",
            display: "flex",
            flexDirection: "column",
            height: "100vh",
            width: "100%",
            // bgcolor:"green"
          }}>

            {isAuthenticated && <Box sx={{
              // bgcolor:grey[50]
              //boxShadow: '0 1px 5px rgba(0,0,0,0.12)',
              bgcolor: backgroundForSystemMenu,
              boxShadow: '0 2px 8px rgba(0,0,0,0.08)', // ombre plus forte
              zIndex: 1000, // pour s'assurer qu'elle reste au-dessus du contenu si besoin
              borderBottom: '1px solid #e2e8f0' // fine bordure en bas
            }}>
              <SystemMenu />
            </Box>}
            {isSearchBoxShow && <FilterFormDialog />}
            {isExportBoxShow && <ExportFormDialog />}
            {isDesktopPublishingBoxShow && <DesktopPublishingFormDialog />}
            {isAuthorizationBoxShow && <AuthorizationFormDialog />}
            <Box
              sx={{ ...boxProps }}
            >
              <Container maxWidth={false} disableGutters={true} sx={{ width: '100%', mb: 1 }}>
                <AppRoute />
                { /*isActionDrawerOpen &&*/ <EntityActionDrawer />}
                {isPrintDrawerOpen && isAuthenticated &&<EntityPrintDrawer />}
                <Box
                  sx={{ display: { xs: 'flex', md: 'none' }, flexWrap: "nowrap", textWrap: "nowrap" }}
                >
                  Kampux - {applicationSetup.companyName}
                </Box>
              </Container>
            </Box>

            {isAuthenticated && <Box sx={displayOnDesktop}>
              <Footer />
            </Box>}
            {isAuthenticated && <SessionTimeout {...{ intialUnixTimeStamp: getUnixTime((new Date())) }} />}
          </Grid>

        </Grid>
      </LocalizationProvider>
    </React.Fragment>
  );
}

export default AppWithSideBar;
